import { useMemo } from 'react';
import { compose, filter, includes, map } from 'ramda';
import { sortByNameCaseInsensitive } from '../pages/helpers/sortByNameCaseInsensitive';

const useUserTeamOptions = ({
  teams,
  disabledTeams
}) => {
  const teamOptions = useMemo(() => {
    const filteredTeams = filter(({ id }) => !includes(id, disabledTeams), teams || []);
    return compose(
      sortByNameCaseInsensitive('label'),
      map(({ id, name }) => ({ value: id, label: name }))
    )(filteredTeams);
  }, [teams, disabledTeams]);

  return teamOptions;
};

export default useUserTeamOptions;